import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getScrollItemAttributeProp } from 'utils/scroll/scrollElementUtils';

export default class MatrixRow extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    form: PropTypes.string,
  };

  static defaultProps = {
    form: '',
  };

  render() {
    const { className, children, form, ...rest } = this.props;

    return (
      <tr {...getScrollItemAttributeProp(form)} className={className} {...rest}>
        {children}
      </tr>
    );
  }
}
